import { validateArguments } from '../../SignatureValidation';
export var PluckFn;
(function (PluckFn) {
    PluckFn.Name = `PLUCK`;
    PluckFn.Stage = "SCALAR";
    PluckFn.Signature = `PLUCK(<value>, <delimiter>, <tokenNumber>)`;
    function make(callName, args, type, role) {
        return {
            name: PluckFn.Name,
            stage: PluckFn.Stage,
            data: { role, type },
            value: (...values) => {
                if (values.length !== 3) {
                    throw new Error(`PLUCK function expects 3 arguments ` +
                        `but received ${values.length}`);
                }
                const [value, delimiter, tokenNumber] = values;
                if (value == null ||
                    delimiter == null ||
                    tokenNumber == null ||
                    tokenNumber === 0) {
                    return null;
                }
                if (typeof value === 'string' &&
                    typeof delimiter === 'string' &&
                    typeof tokenNumber === 'number') {
                    const tokenArr = delimiter === '' ? [...value] : value.split(delimiter);
                    let result;
                    if (tokenNumber < 0) {
                        result = tokenArr.at(tokenNumber);
                    }
                    else {
                        result = tokenArr.at(tokenNumber - 1);
                    }
                    if (result === undefined) {
                        return null;
                    }
                    return result;
                }
                throw new Error(`PLUCK function expects its first two argument to be a string and third argument to be integer ` +
                    `but received (${typeof value}, ${typeof delimiter}, ${typeof tokenNumber})`);
            },
        };
    }
    PluckFn.make = make;
    function validate(callNode, callName, args) {
        const sig = {
            meta: {
                name: PluckFn.Name,
                signature: PluckFn.Signature,
                location: callNode.location,
            },
            arguments: [
                "STRING",
                "STRING",
                "INTEGER",
            ],
        };
        return validateArguments(sig, args);
    }
    PluckFn.validate = validate;
})(PluckFn || (PluckFn = {}));
